import React, { useContext } from "react";
import { Link, useNavigate } from "react-router";
import AuthContext from "../global/auth-context";
import HeaderNav from "./HeaderNav";

const Menu = ({ page }) => {
  let { isAuth, logout, userData, setMenuOpen } = useContext(AuthContext);
  let navigate = useNavigate();
  return (
    <div>
      <HeaderNav />
      <div className=" phone gap-7 h-full w-full bg-myLightGreen flex-1 absolute  z-50 flex flex-col items-center pt-5">
        <div className=" flex flex-col w-full items-center gap-5">
          <a
            href={"/"}
            className="font-bold text-xl text-myNormalGreen  hover:text-yellow-500"
          >
            Home
          </a>
          {isAuth && (
            <a
              href={"/profile"}
              className="font-bold text-xl text-myNormalGreen  hover:text-yellow-500"
            >
              Profile
            </a>
          )}
          <a
            href={"/premium"}
            className={`font-bold text-xl text-myNormalGreen  hover:text-yellow-500 ${
              isAuth && userData.role == "paid" && "hidden"
            }`}
          >
            Get Premium
          </a>
          <a
            href={"/convert"}
            className="font-bold text-xl text-myNormalGreen  hover:text-yellow-500"
          >
            Convert
          </a>
          <a
            href={"/buy-units"}
            className="font-bold text-xl text-myNormalGreen  hover:text-yellow-500"
          >
            Buy Units
          </a>
          <a
            href={"/download-app"}
            className="font-bold text-xl text-myNormalGreen  hover:text-yellow-500"
          >
            Download App
          </a>
        </div>
        <div className="gap-2 flex h-10 justify-center items-center ">
          {isAuth ? (
            <>
              <a
                href="/"
                onClick={() => {
                  logout();
                }}
                className="h-8 bg-red-400 py-1 px-3 rounded-md text-black font-bold"
              >
                Logout
              </a>
            </>
          ) : (
            <>
              <a
                href={"/login"}
                className="h-8 bg-yellow-500 hover:text-white hover:bg-myNormalGreen  py-1 px-3 rounded-md text-black font-bold"
              >
                Login
              </a>
              <a
                href={"/register"}
                className="h-8  bg-yellow-500 hover:text-white hover:bg-myNormalGreen py-1 px-2 rounded-md text-black font-bold"
              >
                SignUp
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Menu;
